import axios from "axios"
import {mapMutations} from "vuex"

export default {
    data(){
        return {
            loading: false,
            token: localStorage.getItem("access_token") ? localStorage.getItem("access_token") : "",
            user: JSON.parse(localStorage.getItem("user")) || {},
            base_url: process.env.NODE_ENV === 'development' ?   'http://127.0.0.1:8000/api/' : 'https://tbd.kamifatech.co.zw/api/' ,
            image_url: process.env.NODE_ENV === 'development' ?  'http://127.0.0.1:8000/uploads/' : 'https://tbd.kamifatech.co.zw/uploads/',
            file_url: process.env.NODE_ENV === 'development' ?  'http://127.0.0.1:8000/files/' : 'https://tbd.kamifatech.co.zw/files/',
            // base_url: 'https://tbd.kamifatech.co.zw/api/',
            error: "",
            message: "",
            joined: false
        }
    },
    methods: {
        ...mapMutations(["updateMessages", "updateUser"]),
        timeFromDate(string){
            let dat = new Date(string)
            var currentDate = new Date();

            if(currentDate.getDate() === dat.getDate()){
                return "Today at "+ dat.toLocaleTimeString()
            }
            else if((currentDate.getDate() - 1) === dat.getDate()){
                return "Yesterday at "+ dat.toLocaleTimeString()
            }
            else{
                return  dat.getDate().toString()+"-"+(dat.getMonth()+1).toString()+" "+ dat.toLocaleTimeString()
            }
        },
        refreshMessages(type, id){
            axios.get(this.base_url+type+"/messages/"+id, this.requestAuthHeaderToken(localStorage.getItem("token"))).then(
                response=>{
                    this.updateMessages(response.data.data.reverse())
                }).catch(error=>{this.error = error})
        },
        loadUser: function () {
            axios.get(this.base_url + "profile", this.requestAuthHeaderToken(localStorage.getItem("token"))).then(
                response => {
                    this.updateUser(response.data.data)
                    // if (this.$route.path.indexOf("admin") && !response.data.data.admin) {
                    //     this.$router.push("/home")
                    // }
                }).catch(error => {
                    this.error = error
                    if(error.response.status){
                        this.logout()
                    }
            })
        },
        postRequestAuth(url, data){
            axios.post(this.base_url+url, data, this.requestAuthHeader()).then(response=>{this.stands = response}).catch(error=>{this.error = error})
        },
        getRequestAuth(url){
            axios.get(this.base_url+url, this.requestAuthHeader()).then(response=>{return response}).catch(error=>{return error})
        },
        resetMessages(){
            this.error = ""
            this.message = ""
        },
        goBack(){
            this.$router.back()
        },
        logout(){
            localStorage.clear();

            if(this.$route.path === "/"){
                location.reload();
            }
            else{
                this.$router.push("/")
            }
        },
        requestHeader(){
            return {
                headers: {
                    Accept: "application/json"
                }
            }
        },
        requestAuthHeader(){
            return {
                headers: {
                    Authorization: "Bearer "+this.token,
                    Accept: "application/json"
                }
            }
        },
        requestAuthHeaderToken(token){
            return {
                headers: {
                    Authorization: "Bearer "+token,
                    Accept: "application/json"
                }
            }
        },
        generateClass(message){
            if(message.user.id === this.user.id){
                return 'alert mb-4 rounded-s bg-green1-dark message-sent';
            }
            return 'alert mb-4 rounded-s bg-green1-dark message-received';
        },
        generateClassAlert(message){
            if(message.user.id === this.user.id){
                return 'alert-icon alert-received';
            }
            return 'alert-icon alert-sent';
        },
        joinStandProject(stand){
            this.loading = true
            this.stand = stand
            axios.post(this.base_url+"stands/join/"+stand.id,{},
                this.requestAuthHeaderToken(localStorage.getItem("token")
                )).then(response=>{
                this.message = response.data.message
                this.joined = true
                this.loading = false
            }).catch(error=>{
                this.error = error
                this.loading = false
            })
        },
        joinRoundProject(round){
            this.loading = true
            this.round = round
            axios.post(this.base_url+"rounds/join/"+round.id,{},
                this.requestAuthHeaderToken(localStorage.getItem("token")
                )).then(response=>{
                this.message = response.data.message
                this.joined = true
                this.loading = false
            }).catch(error=>{
                this.error = error
                this.loading = false
            })
        },
        joinFarmingProject(farming){
            this.loading = true
            this.round = farming
            axios.post(this.base_url+"farming/join/"+farming.id,{},
                this.requestAuthHeaderToken(localStorage.getItem("token")
                )).then(response=>{
                this.message = response.data.message
                this.joined = true
                this.loading = false
            }).catch(error=>{
                this.error = error
                this.loading = false
            })
        },
        joinInvestmentProject(investment){
            this.loading = true
            this.investment = investment
            axios.post(this.base_url+"investments/join/"+investment.id,{},
                this.requestAuthHeaderToken(localStorage.getItem("token")
                )).then(response=>{
                this.message = response.data.message
                this.joined = true
                this.loading = false
            }).catch(error=>{
                this.error = error
                this.loading = false
            })
        },
        formatDate(date){
            var d = new Date(date)
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            return d.getDate() + " " +months[d.getMonth()]+ ' ' +d.getFullYear()
        }
    },
}